// Íconos de las apps: una sola familia (Remix, variante de línea, cargada por
// CDN en index.html) y en currentColor. El recuadro y el color los pone
// appTile.ts: antes cada app traía un fondo saturado distinto (azul, naranja,
// rojo, teal, índigo, ámbar...) y dos familias de íconos mezcladas (Font
// Awesome sólido + Remix línea), y el color no significaba nada.
import type { TFunction } from "i18next";
import type { AppCategory } from "./types";
import { ADMIN_RESELLER_ROLE_ID } from "../../../hooks/useIsReseller";

export const getAppCategories = (t: TFunction): AppCategory[] => [
  {
    id: "rastreo-telemetria",
    title: t("categories.rastreo-telemetria.title"),
    description: t("categories.rastreo-telemetria.description"),
    icon: "ri-truck-line",
    apps: [
      {
        id: "lite",
        name: t("apps.lite.name"),
        description: t("apps.lite.description"),
        icon: <i className="ri-map-2-line" />,
        color: "bg-primary-500",
        route: "/map",
      },
      {
        id: "admin",
        name: t("apps.admin.name"),
        description: t("apps.admin.description"),
        icon: <i className="ri-truck-line" />,
        color: "bg-blue-500",
        route: "/admin/units",
      },
      {
        id: "reportes",
        name: t("apps.reportes.name"),
        description: t("apps.reportes.description"),
        icon: <i className="ri-bar-chart-box-line" />,
        color: "bg-orange-500",
        route: "/reports/history",
      },
      {
        id: "torre-control",
        name: t("apps.torre-control.name"),
        description: t("apps.torre-control.description"),
        icon: <i className="ri-radar-line" />,
        color: "bg-red-500",
        route: "/torre-control",
        badge: "Pro",
        badgeColor: "bg-orange-400",
        isLocked: true,
      },
      // {
      //   id: "oasis",
      //   name: t("apps.oasis.name"),
      //   description: t("apps.oasis.description"),
      //   icon: (
      //     <FontAwesomeIcon icon={faWarehouse} className="text-white text-xl" />
      //   ),
      //   color: "bg-teal-500",
      //   route: "/oasis/yards",
      //   badge: "Pro",
      //   badgeColor: "bg-orange-400",
      //   isLocked: true,
      // },
      {
        id: "truck-yard",
        name: t("apps.truck-yard.name"),
        description: t("apps.truck-yard.description"),
        icon: <i className="ri-parking-box-line" />,
        color: "bg-teal-500",
        route: "/truck-yard",
      },
      {
        id: "inspecciones",
        name: t("apps.inspecciones.name"),
        description: t("apps.inspecciones.description"),
        icon: <i className="ri-survey-line" />,
        color: "bg-indigo-500",
        route: "/inspecciones",
      },
      {
        id: "entrega-servicio-dashboard",
        name: t("apps.entrega-servicio-dashboard.name", "Entrega de Servicio"),
        description: t("apps.entrega-servicio-dashboard.description", "Dashboard de estado de servicio"),
        icon: <i className="ri-task-line" />,
        color: "bg-green-500",
        route: "/entrega-servicio-dashboard",
      },
      {
        id: "fleet-integradores",
        name: t("apps.integradores.name"),
        description: t("apps.integradores.description"),
        icon: <i className="ri-plug-line" />,
        color: "bg-cyan-600",
        route: "/flota/integradores",
      },
      {
        id: "papelera",
        name: t("apps.papelera.name"),
        description: t("apps.papelera.description"),
        icon: <i className="ri-delete-bin-line" />,
        color: "bg-red-600",
        route: "/papelera",
      },
    ],
  },
  {
    id: "administracion",
    title: t("categories.administracion.title"),
    description: t("categories.administracion.description"),
    icon: "ri-settings-3-line",
    apps: [
      {
        id: "facturacion",
        name: t("apps.facturacion.name"),
        description: t("apps.facturacion.description"),
        icon: <i className="ri-bill-line" />,
        color: "bg-purple-500",
        route: "/facturacion/resumen",
      },
      {
        id: "servicios",
        name: t("apps.servicios.name"),
        description: t("apps.servicios.description"),
        icon: <i className="ri-file-list-3-line" />,
        color: "bg-indigo-500",
        route: "/entrega-servicio",
      },
      {
        id: "mapon",
        name: "Mapon",
        description: "Partner Platform",
        icon: <i className="ri-server-line" />,
        color: "bg-amber-500",
        route: "/dashboards/mapon",
      },
      {
        id: "wialon",
        name: "Wialon",
        description: "Partner Platform",
        icon: <i className="ri-signal-tower-line" />,
        color: "bg-orange-500",
        route: "/dashboards/wialon",
      },
      {
        id: "servicios-tecnicos",
        name: t("apps.servicios-tecnicos.name"),
        description: t("apps.servicios-tecnicos.description"),
        icon: <i className="ri-tools-line" />,
        color: "bg-gray-600",
        route: "/servicios-tecnicos",
        isComingSoon: true,
      },
      {
        id: "ajustes",
        name: t("apps.ajustes.name"),
        description: t("apps.ajustes.description"),
        icon: <i className="ri-settings-3-line" />,
        color: "bg-slate-500",
        route: "/ajustes",
      },
      {
        id: "settings",
        name: t("apps.settings.name"),
        description: t("apps.settings.description"),
        icon: <i className="ri-equalizer-2-line" />,
        color: "bg-sky-500",
        route: "/settings",
        isComingSoon: true,
      },
      {
        id: "support",
        name: t("apps.support.name"),
        description: t("apps.support.description"),
        icon: <i className="ri-customer-service-2-line" />,
        color: "bg-rose-500",
        route: "/support",
      },
    ],
  },
  {
    id: "point-of-sale",
    title: t("categories.point-of-sale.title"),
    description: t("categories.point-of-sale.description"),
    icon: "ri-store-2-line",
    apps: [
      {
        id: "pos-cashier",
        name: t("apps.pos-cashier.name"),
        description: t("apps.pos-cashier.description"),
        icon: <i className="ri-cash-line" />,
        color: "bg-emerald-500",
        route: "/pos/cashier/terminal",
        badge: "New",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "pos-products",
        name: t("apps.pos-products.name"),
        description: t("apps.pos-products.description"),
        icon: <i className="ri-archive-line" />,
        color: "bg-blue-500",
        route: "/pos/products/list",
      },
      {
        id: "pos-inventory",
        name: t("apps.pos-inventory.name"),
        description: t("apps.pos-inventory.description"),
        icon: <i className="ri-stack-line" />,
        color: "bg-amber-500",
        route: "/pos/inventory/stock",
      },
      {
        id: "pos-coupons",
        name: t("apps.pos-coupons.name"),
        description: t("apps.pos-coupons.description"),
        icon: <i className="ri-coupon-3-line" />,
        color: "bg-pink-500",
        route: "/pos/coupons/list",
      },
      {
        id: "pos-orders",
        name: t("apps.pos-orders.name"),
        description: t("apps.pos-orders.description"),
        icon: <i className="ri-shopping-bag-3-line" />,
        color: "bg-indigo-500",
        route: "/pos/orders/sales",
      },
      {
        id: "pos-ecommerce",
        name: t("apps.pos-ecommerce.name"),
        description: t("apps.pos-ecommerce.description"),
        icon: <i className="ri-store-2-line" />,
        color: "bg-violet-500",
        route: "/pos/ecommerce/dashboard",
        badge: "Pro",
        badgeColor: "bg-orange-400",
        isLocked: true,
      },
    ],
  },
  {
    id: "internos",
    title: t("categories.internos.title"),
    description: t("categories.internos.description"),
    icon: "ri-tools-line",
    requiredRoleIds: [ADMIN_RESELLER_ROLE_ID],
    apps: [
      {
        id: "reseller-admin",
        name: t("apps.reseller-admin.name"),
        description: t("apps.reseller-admin.description"),
        icon: <i className="ri-building-2-line" />,
        color: "bg-blue-600",
        route: "/reseller-admin",
        isBeta: true,
      },
      {
        id: "sg",
        name: t("apps.sg.name"),
        description: t("apps.sg.description"),
        icon: <i className="ri-global-line" />,
        color: "bg-teal-600",
        route: "/sg/cuadre",
        isBeta: true,
      },
      {
        id: "cobranza",
        name: t("apps.cobranza.name"),
        description: t("apps.cobranza.description"),
        icon: <i className="ri-money-dollar-circle-line" />,
        color: "bg-emerald-500",
        route: "/cobranza",
        isBeta: true,
      },
      {
        id: "dashboards",
        name: t("apps.dashboards.name"),
        description: t("apps.dashboards.description"),
        icon: <i className="ri-dashboard-line" />,
        color: "bg-violet-500",
        route: "/dashboards",
        badge: "Beta",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "ai",
        name: t("apps.ai.name"),
        description: t("apps.ai.description"),
        icon: <i className="ri-robot-2-line" />,
        color: "bg-gradient-to-br from-emerald-500 to-cyan-500",
        route: "/ai",
        badge: "Beta",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "xml",
        name: t("apps.xml.name"),
        description: t("apps.xml.description"),
        icon: <i className="ri-file-code-line" />,
        color: "bg-gradient-to-br from-emerald-500 to-cyan-500",
        route: "/xml",
        badge: "Beta",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "integradores",
        name: t("apps.integradores.name"),
        description: t("apps.integradores.description"),
        icon: <i className="ri-plug-2-line" />,
        color: "bg-cyan-600",
        route: "/integradores",
        badge: "Beta",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "papelera-interno",
        name: t("apps.papelera-interno.name"),
        description: t("apps.papelera-interno.description"),
        icon: <i className="ri-delete-bin-2-line" />,
        color: "bg-red-600",
        route: "/papelera-interno",
      },
      {
        id: "service-desk",
        name: t("apps.service-desk.name"),
        description: t("apps.service-desk.description"),
        icon: <i className="ri-lifebuoy-line" />,
        color: "bg-cyan-500",
        route: "/service-desk",
        badge: "Beta",
        badgeColor: "bg-emerald-400",
      },
      {
        id: "respaldos",
        name: t("apps.respaldos.name"),
        description: t("apps.respaldos.description"),
        icon: <i className="ri-database-2-line" />,
        color: "bg-slate-600",
        route: "/respaldos",
      },
      {
        id: "compras",
        name: t("apps.compras.name"),
        description: t("apps.compras.description"),
        icon: <i className="ri-shopping-cart-2-line" />,
        color: "bg-amber-500",
        route: "/compras",
        isComingSoon: true,
      },
      {
        id: "logistica",
        name: t("apps.logistica.name"),
        description: t("apps.logistica.description"),
        icon: <i className="ri-route-line" />,
        color: "bg-cyan-500",
        route: "/logistica",
        isComingSoon: true,
      },
    ],
  },
];
